import tree from "../../../components/tree.vue";
import Unaccepted from "./Unaccepted/Unaccepted.vue"
import Repaired from "./Repaired/Repaired.vue"
import AlreadyRepaired from "./AlreadyRepaired/AlreadyRepaired.vue"
import Closed from "./Closed/Closed.vue"

export default {
    name: 'RepairManagement',
    components: { tree, Unaccepted, Repaired, AlreadyRepaired, Closed },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            id: '',
            activeName: 'first',
        }
    },
    created() {
        // 从URL参数中获取tabName，如果存在则设置为当前激活的tab
        if (this.$route.query.tabName) {
            this.activeName = this.$route.query.tabName;
        }
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        cellClick(val) {
            console.log('val====>', val)
            if (val.row.repairStateStr == this.$t('VehicleManagement.form.haveBeenRepaired')) {
                this.activeName = 'second'
                this.$refs.TabMaintenance.orgId = this.orgId
                this.$refs.TabMaintenance.repairSerialNumber = val.row.repairSerialNumber
                this.$refs.TabMaintenance.getMaintainList()
                this.$refs.TabMaintenance.dialogOperateVisible = true
                this.$refs.TabMaintenance.queryDetails()
            } else {
                this.$message.error(this.$t('VehicleManagement.form.noClick'))
            }
        },
        initQuery(item) {
            console.log(item)
            this.orgId = item.id
            if (this.activeName == 'first') {
                this.$refs.unaccept.orgId = item.id
                this.$refs.unaccept.getRepairList()
            } else if(this.activeName == 'second') {
                this.$nextTick(() => {
                    this.$refs.repair.orgId = item.id
                    this.$refs.repair.getRepairList()
                })
            } else if(this.activeName == 'third') {
                this.$nextTick(() => {
                    this.$refs.alreadyRepair.orgId = item.id
                    this.$refs.alreadyRepair.getRepairList()
                })
            }
            else {
                this.$nextTick(() => {
                    this.$refs.close.orgId = item.id
                    this.$refs.close.getRepairList()
                })
            }
        },
        nodeClick(val) {
            this.orgId = val.label
            if (this.activeName === 'first') {
                this.$refs.unaccept.orgId = val.label
                this.$refs.unaccept.getRepairList()
            } else if(this.activeName === 'second') {
                this.$nextTick(() => {
                    this.$refs.repair.orgId = val.label
                    this.$refs.repair.getRepairList()
                })
            } else if(this.activeName === 'third') {
                this.$nextTick(() => {
                    this.$refs.alreadyRepair.orgId = val.label
                    this.$refs.alreadyRepair.getRepairList()
                })
            }
            else {
                this.$nextTick(() => {
                    this.$refs.close.orgId = val.label
                    this.$refs.close.getRepairList()
                })
            }
        },
        handleClick(event) {
            console.log(event)
            this.activeName = event.name
            if (this.activeName == 'first') {
                this.$refs.unaccept.getRepairList(this.orgId)
            } else if(this.activeName === 'second') {
                this.$nextTick(() => {
                    this.$refs.repair.orgId = this.orgId
                    this.$refs.repair.getRepairList()
                })
            } else if(this.activeName === 'third') {
                this.$nextTick(() => {
                    this.$refs.alreadyRepair.orgId = this.orgId
                    this.$refs.alreadyRepair.getRepairList()
                })
            }
            else {
                this.$nextTick(() => {
                    this.$refs.close.orgId = this.orgId
                    this.$refs.close.getRepairList()
                })

            }
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}